import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ScanHash from '../../components/ScanHash';
import './index.less';

const ScanHashPage: React.FC = () => {
  const { hash } = useParams();
  const navigate = useNavigate();

  if (!hash) return null;

  return (
    <ScanHash 
      hash={hash}
      onCancel={() => navigate('/')}
      onCollect={({ bpm, songId }) => navigate(`/?bpm=${bpm}&songId=${songId}`)}
    />
  );
};

export default ScanHashPage;
